// /* eslint-disable */
// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import "./TowerFTEChart.css";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// const TowerFTEChart = ({ data }) => {
//   const validLabels = data.labels.map((label) => label || "N/A");

//   const chartData = {
//     labels: validLabels,
//     datasets: [
//       { label: "Projection", data: data.projection, backgroundColor: "#156082" },
//       { label: "PO Received", data: data.PO_Received, backgroundColor: "#4bacc6" },
//       { label: "PO Awaited", data: data.PO_Awaited, backgroundColor: "#00b0f0" },
//       { label: "Excom Approval Received", data: data.excomApprovalReceived, backgroundColor: "#92d050" },
//       { label: "Excom Awaited", data: data.excomAwaited, backgroundColor: "#196b24" },
//       { label: "Discussion in Progress", data: data.discussionInProgress, backgroundColor: "#0f9ed5" },
//       { label: "To be Explored", data: data.toBeExplored, backgroundColor: "#a02b93" },
//       { label: "Not Applicable", data: data.Not_Applicable, backgroundColor: "#ffc000" },
//       { label: "Dropped", data: data.Dropped, backgroundColor: "#c00000" },
//       { label: "As Null", data: data.as_null, backgroundColor: "#7f7f7f" },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "bottom",
//         labels: {
//           boxWidth: 12,
//         },
//       },
//       datalabels: {
//         display: false,
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: {
//           display: true,
//           text: "FTE Count",
//         },
//         ticks: {
//           stepSize: 20,
//         },
//       },
//     },
//   };

//   const calcTotal = (arr) => (arr && arr.length ? arr.reduce((a, b) => a + b, 0) : 0);

//   const totals = {
//     projection: calcTotal(data.projection),
//     PO_Received: calcTotal(data.PO_Received),
//     PO_Awaited: calcTotal(data.PO_Awaited),
//     excomApprovalReceived: calcTotal(data.excomApprovalReceived),
//     excomAwaited: calcTotal(data.excomAwaited),
//     discussionInProgress: calcTotal(data.discussionInProgress),
//     toBeExplored: calcTotal(data.toBeExplored),
//     Not_Applicable: calcTotal(data.Not_Applicable),
//     Dropped: calcTotal(data.Dropped),
//     as_null: calcTotal(data.as_null),
//   };

//   return (
//     <div className="tower-fte-container card p-3">
//       {/* Chart Section */}
//       <div className="chart-wrapper">
//         <Bar data={chartData} options={options} />
//       </div>
//       {/* Table Section */}
//       <div className="table-wrapper mt-3">
//         <table className="fte-table">
//           <thead>
//             <tr>
//               <th></th>
//               {validLabels.map((label, idx) => (
//                 <th key={idx}>{label}</th>
//               ))}
//               <th>Total</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>Projection</td>
//               {data.projection.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.projection}</td>
//             </tr>
//             <tr>
//               <td>PO Received</td>
//               {data.PO_Received.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.PO_Received}</td>
//             </tr>
//             <tr>
//               <td>PO Awaited</td>
//               {data.PO_Awaited.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.PO_Awaited}</td>
//             </tr>
//             <tr>
//               <td>Excom Approval Received</td>
//               {data.excomApprovalReceived.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.excomApprovalReceived}</td>
//             </tr>
//             <tr>
//               <td>Excom Awaited</td>
//               {data.excomAwaited.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.excomAwaited}</td>
//             </tr>
//             <tr>
//               <td>Discussion in Progress</td>
//               {data.discussionInProgress.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.discussionInProgress}</td>
//             </tr>
//             <tr>
//               <td>To be Explored</td>
//               {data.toBeExplored.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.toBeExplored}</td>
//             </tr>
//             <tr>
//               <td>Not Applicable</td>
//               {data.Not_Applicable.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.Not_Applicable}</td>
//             </tr>
//             <tr>
//               <td>Dropped</td>
//               {data.Dropped.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.Dropped}</td>
//             </tr>
//             <tr>
//               <td>As Null</td>
//               {data.as_null.map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//               <td>{totals.as_null}</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default TowerFTEChart;

// ########################### New Code #################################
/* eslint-disable */
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import "./TowerFTEChart.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const TowerFTEChart = ({ data }) => {
  const validLabels = data.labels.map((label) => label || "N/A");

  const chartData = {
    labels: validLabels,
    datasets: [
      { label: "Projection", data: data.projection, backgroundColor: "#156082" },
      { label: "PO Received", data: data.PO_Received, backgroundColor: "#4bacc6" },
      { label: "PO Awaited", data: data.PO_Awaited, backgroundColor: "#00b0f0" },
      { label: "Excom Approval Received", data: data.excomApprovalReceived, backgroundColor: "#92d050" },
      { label: "Excom Awaited", data: data.excomAwaited, backgroundColor: "#196b24" },
      { label: "Discussion in Progress", data: data.discussionInProgress, backgroundColor: "#0f9ed5" },
      { label: "To be Explored", data: data.toBeExplored, backgroundColor: "#a02b93" },
      { label: "Not Applicable", data: data.Not_Applicable, backgroundColor: "#ffc000" },
      { label: "Dropped", data: data.Dropped, backgroundColor: "#c00000" },
      { label: "As Null", data: data.as_null, backgroundColor: "#7f7f7f" },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12,
        },
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "FTE Count",
        },
        ticks: {
          stepSize: 20,
        },
      },
    },
  };

  const calcTotal = (arr) =>
    arr && arr.length ? arr.reduce((a, b) => a + (parseFloat(b) || 0), 0) : 0;

  const totals = {
    projection: calcTotal(data.projection),
    PO_Received: calcTotal(data.PO_Received),
    PO_Awaited: calcTotal(data.PO_Awaited),
    excomApprovalReceived: calcTotal(data.excomApprovalReceived),
    excomAwaited: calcTotal(data.excomAwaited),
    discussionInProgress: calcTotal(data.discussionInProgress),
    toBeExplored: calcTotal(data.toBeExplored),
    Not_Applicable: calcTotal(data.Not_Applicable),
    Dropped: calcTotal(data.Dropped),
    as_null: calcTotal(data.as_null),
  };

  const fmt2 = (val) => parseFloat(val || 0).toFixed(2);

  return (
    <div className="tower-fte-container card p-3">
      {/* Chart Section */}
      <div className="chart-wrapper">
        <Bar data={chartData} options={options} />
      </div>

      {/* Table Section */}
      <div className="table-wrapper mt-3">
        <table className="fte-table">
          <thead>
            <tr>
              <th></th>
              {validLabels.map((label, idx) => (
                <th key={idx}>{label}</th>
              ))}
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Projection</td>
              {data.projection.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.projection)}</td>
            </tr>
            <tr>
              <td>PO Received</td>
              {data.PO_Received.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.PO_Received)}</td>
            </tr>
            <tr>
              <td>PO Awaited</td>
              {data.PO_Awaited.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.PO_Awaited)}</td>
            </tr>
            <tr>
              <td>Excom Approval Received</td>
              {data.excomApprovalReceived.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.excomApprovalReceived)}</td>
            </tr>
            <tr>
              <td>Excom Awaited</td>
              {data.excomAwaited.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.excomAwaited)}</td>
            </tr>
            <tr>
              <td>Discussion in Progress</td>
              {data.discussionInProgress.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.discussionInProgress)}</td>
            </tr>
            <tr>
              <td>To be Explored</td>
              {data.toBeExplored.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.toBeExplored)}</td>
            </tr>
            <tr>
              <td>Not Applicable</td>
              {data.Not_Applicable.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.Not_Applicable)}</td>
            </tr>
            <tr>
              <td>Dropped</td>
              {data.Dropped.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.Dropped)}</td>
            </tr>
            <tr>
              <td>As Null</td>
              {data.as_null.map((val, idx) => (
                <td key={idx}>{fmt2(val)}</td>
              ))}
              <td>{fmt2(totals.as_null)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TowerFTEChart;
